import { request } from '@pb/utils'

export const upgradeUserToClub = (data): any =>
  request.post('club/join', { data }).then((res) => res.data)

export const fetchProvinces = (): any => request.get('addresses/provinces').then((res) => res.data)
